export const PROBATION = 'Probation';
export const PERMANENT = 'Permanent';
export const INTERN = 'Intern';
export const TRAINEE = 'Trainee';
export const TERMINATED = 'Terminated';
export const CONSULTANT = 'Consultant';
export const FIXED_TERM_CONTRACT = 'Fixed-term Contract';
export const HIRED = 'Hired';
export const SUB_CONTRACT = 'Sub-Contract';

export const ENGAGEMENT_STATUS_IDS = {
  FIXED_TERM_CONTRACT: 1,
  INTERN: 2,
  PERMANENT: 3,
  PROBATION: 4,
  TERMINATED: 5,
  TRAINEE: 6,
  SUB_CONTRACT: 7,
  HIRED: 8,
};

export const EMPLOYEE_STATUS_STYLES = {
  [FIXED_TERM_CONTRACT]: 'bg-color-pink',
  [INTERN]: 'bg-color-purple',
  [PERMANENT]: 'bg-color-green',
  [PROBATION]: 'bg-color-yellow',
  [TERMINATED]: 'bg-color-red',
  [TRAINEE]: 'bg-color-orange',
  [CONSULTANT]: 'bg-color-blue',
  [SUB_CONTRACT]: 'bg-color-gray',
  [HIRED]: 'bg-color-blue',
};

export const EMPLOYEE_STATUSES = [PROBATION, PERMANENT, INTERN, TRAINEE, TERMINATED, CONSULTANT, SUB_CONTRACT];
